import { render } from "./CinemaMap.vue?vue&type=template&id=060ed1b6"
import script from "./CinemaMap.vue?vue&type=script&lang=js"
export * from "./CinemaMap.vue?vue&type=script&lang=js"

import "./CinemaMap.vue?vue&type=style&index=0&id=060ed1b6&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__